// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import moment from 'moment';
import { Table } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { isMobileResolution } from '../../../../infrastructure/utils/common';
import { getConfig } from '../../../../config';

import PartyBookMarkedTableMobile from './PartyBookMarkedTableMobile';

const StyledContainer = styled.div`
  margin-bottom: 60px;
`;

const StyledRow = styled.tr`
  cursor: pointer;
`;

const config = getConfig();

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const PartyBookMarkedTable = ({ bookMarked }) => {
  const onBookMarkedItemClick = activityId => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    window.open(`${config.batchAdminURL}/experiences/${activityId}`, '_self');
  };

  const getFormattedCreatedDate = item => {
    const { createdAt } = item;
    if (!createdAt) return '';
    return moment(createdAt).format('MM/DD/YYYY hh:mm A');
  };

  return (
    <StyledContainer>
      <h4 className='subheader'>Favoriting list</h4>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {bookMarked.length > 0 ? (
        <>
          {isMobileResolution() ? (
            <PartyBookMarkedTableMobile
              bookMarked={bookMarked}
              getFormattedCreatedDate={getFormattedCreatedDate}
              onBookMarkedItemClick={onBookMarkedItemClick}
            />
          ) : (
            <Table hover>
              <thead>
                <tr>
                  <th>Activity Name</th>
                  <th>Date Favorited</th>
                  <th>User Name Favorited By</th>
                </tr>
              </thead>
              <tbody>
                {/* TODO: Fix this the next time the file is edited. */}
                {/* eslint-disable-next-line react/prop-types */}
                {bookMarked.map(item => (
                  <StyledRow
                    key={item.createdAt}
                    onClick={() => onBookMarkedItemClick(item.activityId)}
                  >
                    <td>{item.activity.title}</td>
                    <td>{getFormattedCreatedDate(item)}</td>
                    <td>{item.creator.memberName}</td>
                  </StyledRow>
                ))}
              </tbody>
            </Table>
          )}
        </>
      ) : (
        'None'
      )}
    </StyledContainer>
  );
};

export default React.memo(PartyBookMarkedTable);
